// local lib
import generateColumnGroup from '../lib/generateColumnGroup.lib';

const customColumnGroup = generateColumnGroup({
  name: 'Custom',
  columns: [],
});

export default customColumnGroup;
